<template>
    <div class="flex">
        <DatePicker
            v-on:input="changeDate"
            :value="values"
            :placeholder="labelText"
            type="daterange"
        ></DatePicker>
    </div>
</template>

<script>
import DatePicker from "@/components/templates/DatePicker";

export default {
    props: {
        labelText: { type: String },
        columnName: { type: String },
        initialFromValue: { type: String, default: "" },
        initialToValue: { type: String, default: "" }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            values: [this.initialFromValue, this.initialToValue],
        };
    },
    methods: {
        changeDate(e) {
            this.values = e || [];
        },
        clearFilter() {
            this.values = [];
        },
        getFilter() {
            if (!this.values[0] && !this.values[1]) {
                return null;
            }

            return [
                {
                    columnName: this.columnName,
                    fieldType: "D",
                    matchType: "GE",
                    value: this.values[0]
                },
                {
                    columnName: this.columnName,
                    fieldType: "D",
                    matchType: "LE",
                    value: this.values[1]
                }
            ];
        },
        setFilter(filter) {
            if (filter.matchType === "GE") {
                this.values[0] = filter.value;
            } else if (filter.matchType === "LE") {
                this.values[1] = filter.value;
            }
        }
    }
};
</script>